// useForm.js
import { useState } from 'react';
import { _setAxios, _success } from 'lib/Helper';

const useSend = (data, fetchTable, hideModal) => {
    const [loading, setLoading] = useState(false);

    const handleSubmit = (val) => {
        setLoading(true);
        let endpoint = "penilaian/mapel/rombel/status-complete";
        let method = "POST";

        _setAxios(endpoint, method, {
            "tahun_ajaran_id": data?.tahun_ajaran_id,
            "semester_id": data?.semester_id,
            "rombel_id": data?.rombel_id,
            "mapel_id": data?.mapel_id,
            "status": data?.status === "1" ? "0" : "1"
        }).then(resp => {
            if (resp.status) {
                _success('topRight', 'Success', resp.data.message)
                fetchTable(true);
                hideModal();
            }
            setLoading(false);
        }).catch(err => {
            setLoading(false);
        });
    };

    return {
        loading,
        handleSubmit,
    };
};

export default useSend;
